import { Component, Input, Output, EventEmitter, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextInput } from '../text-input/text-input';
import { Button } from '../button/button';

@Component({
  selector: 'app-create-batch-modal',
  standalone: true,
  imports: [CommonModule, TextInput, Button],
  templateUrl: './create-batch-modal.html',
  styleUrl: './create-batch-modal.css'
})
export class CreateBatchModal {
  @Input() isSaving: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<{ name: string; description: string }>();

  batchName = signal('');
  description = signal('');
  maxDescriptionLength = 320;

  onCancel() {
    this.close.emit();
  }

  onSave() {
    if (!this.batchName().trim() || this.isSaving) return;
    this.save.emit({ name: this.batchName(), description: this.description() });
  }
}